import { Component, effect, OnDestroy, OnInit, signal, ViewChild, WritableSignal } from '@angular/core';
import { BrowserSnifferService } from '@tt-lib/services/browser-sniffer.service';
import { LegendService } from '@tt-lib/components/legend/legend.service';
// import { GeocodingComponent } from '@tt-lib/components/geocoding/geocoding.component';
// import { ShareMapComponent } from '@tt-lib/components/share-map/share-map.component';
import { MapService } from '@tt-lib/services/map.service';
// import { PdfService } from '@tt-lib/components/pdf/pdf.service';
// import { PermalinkService } from '@tt-lib/services/permalink.service';
import { filter, switchMap, take } from 'rxjs/operators';
import { TraceDrawerType, TraceRouteDataUpdateType, TraceService } from '@tt-lib/services/trace.service';
import { environment } from '../../../environments/environment';
import { merge, Subscription } from 'rxjs';
// import { SendRemarkComponent } from '@tt-lib/components/send-remark/send-remark.component';
// import { MeasureComponent } from '@tt-lib/components/measure/measure.component';
import { PopupService } from '@tt-lib/services/popup.service';
// import { TraceWayPointType } from '@tt-lib/models/trace-route-data';
import { ViewService } from '@tt-lib/services/view.service';
import { LayerService } from '@tt-lib/services/layers/layer.service';
import { OlLayerService } from '@tt-lib/services/ol/ol-layer.service';
import { TraceRouteHistory } from '@tt-lib/models/trace-route-history';
import TileState from 'ol/TileState';
import { HttpClient } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { HeaderComponent } from '@tt-lib/components/header/header.component';
import { LanguageChooserComponent } from '@tt-lib/components/language-chooser/language-chooser.component';
import { MapComponent } from '@tt-lib/components/map/map.component';
import { BaseLayerThemeSelectorComponent } from '@tt-lib/components/base-layer-theme-selector/base-layer-theme-selector.component';
import { LogoComponent } from '../logo/logo.component';
import { ThemeSwitchComponent } from '../theme-switch/theme-switch.component';
import { TranslateModule } from '@ngx-translate/core';
import { AppEventService, PermalinkService } from '@tt-lib/services/permalink.service';
import { ZoomComponent } from '@tt-lib/components/zoom/zoom.component';
import { MousePositionComponent } from '@tt-lib/components/mouse-position/mouse-position.component';
import { LegendComponent } from '@tt-lib/components/legend/legend.component';
import { MeasureComponent } from '@tt-lib/components/measure/measure.component';
import { SendRemarkComponent } from '@tt-lib/components/send-remark/send-remark.component';
import { DrawingToolsComponent } from '@tt-lib/components/trace/trace-create/drawing-tools/drawing-tools.component'
import { TraceComponent } from '@tt-lib/components/trace/trace.component'
import { TraceWayPointType } from '@tt-lib/models/trace-route-data';
import { ElevationProfileComponent } from '@tt-lib/components/elevation-profile/elevation-profile.component';
import { ShareMapComponent } from '@tt-lib/components/share-map/share-map.component';
//import { GeocodingV2Component } from '@tt-lib/components/geocoding-v2/geocoding-v2.component';
import { GeocodingComponent } from '@tt-lib/components/geocoding/geocoding.component';
import { AlertComponent } from '@tt-lib/components/alert/alert.component';
import { PdfService } from '@tt-lib/components/pdf/pdf.service';
import { BackEventService } from '@tt-lib/services/back-event.service';
import { toObservable } from '@angular/core/rxjs-interop';
import { LanguageService } from '@tt-lib/services/language.service';

@Component({
  selector: 'tt-tmv',
  imports: [
    CommonModule,
    MatToolbarModule,
    MatButtonModule,
    MatSelectModule,
    MatIconModule,
    MatMenuModule,
    MatTooltipModule,
    MatListModule,
    MatCardModule,
    MatCheckboxModule,
    MatDividerModule,
    MatBottomSheetModule,
    MatGridListModule,
    MatSnackBarModule,
    MatDialogModule,
    HeaderComponent,
    LanguageChooserComponent,
    TranslateModule,
    BaseLayerThemeSelectorComponent,
    LogoComponent,
    MapComponent,
    ThemeSwitchComponent,
    ZoomComponent,
    MousePositionComponent,
    LegendComponent,
    MeasureComponent,
    SendRemarkComponent,
    TraceComponent,
    DrawingToolsComponent,
    ElevationProfileComponent,
    ShareMapComponent,
    //GeocodingV2Component,
    GeocodingComponent,
    AlertComponent
  ],
  templateUrl: './tmv.component.html',
  styleUrls: ['./tmv.component.scss'],
  standalone: true
})

export class TmvComponent implements OnInit, OnDestroy {
  //@ViewChild("geocoding") geocoding: GeocodingV2Component;
  @ViewChild("geocoding") geocoding: GeocodingComponent;
  @ViewChild("shareMap") shareMap: ShareMapComponent;
  @ViewChild("themeSwitch") themeSwitch: ThemeSwitchComponent;
  @ViewChild("languageChooser") languageChooser: LanguageChooserComponent;
  @ViewChild("languageChooserTriggerBtn") languageChooserTriggerBtn: MatMenuTrigger;
  // @ViewChild("sendRemark") sendRemark: SendRemarkComponent;
  @ViewChild("measure") measure: MeasureComponent;

  public currentYear = new Date().getFullYear();
  private _subscriptions: Subscription;
  public showTraceViewBtn: WritableSignal<boolean> = signal(false);
  //public showTraceCreateBtn: WritableSignal<boolean> = signal(false);
  private _traceReadOnListener: Subscription;
  private _traceSuggestionsListener: Subscription;
  private wasPhone: boolean;

  constructor(
    public legend: LegendService,
    public browserSniffer: BrowserSnifferService,
    public mapService: MapService,
    public pdfService: PdfService,
    public traceService: TraceService,
    private permalinkService: PermalinkService,
    private appEventService: AppEventService,
    private _popupService: PopupService,
    private _viewService: ViewService,
    public _layerService: LayerService,
    // public olLayerService: OlLayerService,
    private layerService: LayerService,
    public http: HttpClient,
    private backEventService: BackEventService,
    //private geolocationService: GeolocationService,
    private languageService: LanguageService
  ) {

    //other max zoom than default?
    //this.geolocationService.maxAutoZoom = 8;
    //this.traceService.maxAutoZoom = 8;

    effect(() => {
      //this doesn't only happen when you resize the complete browser window
      //se extra test
      const isPhone = this.browserSniffer.isPhone();
      if (isPhone !== this.wasPhone) {
        this.wasPhone = isPhone;
        this.handleSizeChange(isPhone);
      }
    });

    this._subscriptions = new Subscription();
    this._subscriptions.add(
      toObservable(this.languageService.selectedLang).subscribe((value) => {
          this.traceService.checkForWrongSuggestionLang();
      })
    );

  }



  ngOnInit(): void {
    // setTimeout((_) => {
    //  this.pdfService.open();
    // this.traceService.openImportDialog();
    // this.legend.openDialog();
    // this.measure.togglePanel(null);
    // }, 1750);
    // this param is only available in the tmv 
    //console.log('oninit')

    // Universal link subscription
    this._subscriptions.add(
      // universal link Q&D
      this.appEventService.universalLink$
        .pipe(filter(params => !!params))
        .subscribe(params => {
          this.traceService.setPermalinkParam(false);
          this.traceService.fullCleanupAndSaveForHistoryItems();
          this.traceService.addNewHistoryItemForEditing();
          this.traceService.setPermalinkParam(true);
          this.traceService.resetTraceRouteData(true);
          this.loadTrace(params);
        })
    );


    this._subscriptions.add(
      this._viewService.viewReady$
        .pipe(
          filter(isReady => isReady),
          switchMap(() => {
            // Only use getParams() if no universal link exists yet
            if (!this.appEventService.universalLink$.value) {
              return this.permalinkService.getParams().pipe(take(1));
            } else {
              // Return empty observable to skip
              return [];
            }
          })
        )
        .subscribe(params => {
          //console.log('/// normal tmv component', params)
          if (params['trace'] || params['tracetab']) this.loadTrace(params);
        })
    );

    this._subscriptions.add(
      //only phone, tested in the template
      this.traceService.updatedTraceRouteData$.subscribe((traceRouteDataUpdateType: TraceRouteDataUpdateType) => {
        const show = !this.traceService.isInEditingMode() && (this.traceService.hasTraceRouteOrWaypointOnMap() || this.traceService.hasTraceRouteWithGeneralInfo());
        this.showTraceViewBtn.set(show);
        // this.showTraceCreateBtn.set(this.traceService.isInEditingMode() && (this.traceService.hasWayPointsOnMap() || this.traceService.hasRouteOnMap()));
      })
    );

    //phone: readon in popup
    // if (this.browserSniffer.isPhone()) {
    //   if (!this._readOnlistener) { this.setReadOnlistenerClickListener };
    // }

    // this._subscriptions.add(
    //   this.browserSniffer.subscribeToPhoneChanges().subscribe(() => {
    //     if (this.browserSniffer.isPhone()) {
    //       if (this.traceService.isInEditingMode()) {
    //         this.traceService.onOpenCreateMobile();
    //       }
    //       if (!this._readOnlistener) { this.setReadOnlistenerClickListener() };
    //       this._subscriptions.add(this._readOnlistener);
    //       //dt
    //     } else {
    //       this.traceService.closeViewDialog();
    //       this.traceService.closeImportDialog();

    //       if (this.traceService.isInEditingMode()) {
    //         this.traceService.closeCreateBottomSheet();
    //         this.traceService.openTraceTab(TraceDrawerType.CREATE_ROUTE);
    //       }
    //       if (this._readOnlistener) {
    //         this._subscriptions.remove(this._readOnlistener);
    //         this._readOnlistener.unsubscribe();
    //         this._readOnlistener = null;
    //       }
    //     }
    //   })
    // );

    // blob the top10 tile images to avoid cors, they are served via tmv-services(on ios)
    this._subscriptions.add(
      this.layerService.baseLayersReady$.subscribe((isReady) => {
        if (isReady) {
          this.setTop10mapTileLoadFunction((this._layerService.getLayerById('top10map') as any).getSource());
          this.setTop10mapTileLoadFunction((this._layerService.getLayerById('top10map_g') as any).getSource());
        }
      })
    )

    this.backEventService.initializeBackEventListener();
  }

  sjappi() {

    navigator.geolocation.getCurrentPosition(
      (position) => console.log("Location granted:", position),
      (err) => console.log("Location denied", err)
    );

  }

  loadTrace(params) {
    //param trace has priority over param tracetab
    if (params["trace"] != undefined) {
      //a permalink will always contain the parameter tracezoom=true
      const zoomToExtent = (/^(true|1)$/i).test(params["tracezoom"]);
      //this parameter is normally removed by method PermalinkService.updateTraceParam, but we can remove it already here
      this.permalinkService.updateTraceZoomParam(false);
      if (TraceRouteHistory.isLocalStorageDataReference(params["trace"])) {
        this.traceService.loadTraceRouteDataFromLocalStorage(false, zoomToExtent, params["trace"]);
      } else {
        this.traceService.loadTraceRouteDataFromExternalStorage(zoomToExtent, environment.AC_TRACE_DOWNLOAD_APP_ID, params["trace"]).subscribe();
      }
    } else if (params["tracetab"] != undefined) {
      this.traceService.startupWithTraceTab(params["tracetab"]);
    }
  }


  setTop10mapTileLoadFunction(src) {
    src.setTileLoadFunction(
      (tile, src) => {
        this.http.get(src, { responseType: 'blob' })
          .subscribe({
            next: (blob) => {
              if (blob) {
                tile.getImage().src = URL.createObjectURL(blob);
              } else {
                tile.setState(TileState.ERROR);
              }
            },
            error: () => {
              tile.setState(TileState.ERROR);
            }
          });
      });
  }
  ngOnDestroy(): void {
    this._subscriptions.unsubscribe();

    if (this.traceService.isActive()) {
      //in some cases the trace service works without the trace componnent (phone)
      this.traceService.shutDown();
    }

    this.backEventService.removeBackEventListener();
  }
  ngAfterViewInit() {
    //?addlayer.attribution to layer object 
    // new ol.control.Attribution({collapsible: false});
    //show/hide tomtom copyright

    //   this.mapService.getMap().getLayers().on("propertychange", function(e) {
    //     // triggered when layer added or removed
    //     console.log('layer event...');
    //     console.dir(e)
    // });


    let attribution_tomtom_layers = ['crossborder.topo', 'ngi.cartoweb.topo.be', 'ngi.cartoweb.topo_bw.be', 'overlay.ortho', 'ortho.overlay'];

    this._subscriptions.add(
      this._layerService.activeBaselayerId$.subscribe((activeLayerId) => {
        const zoomlevel: number = this.mapService.getMap().getView().getZoom();
        if (zoomlevel > 7 && attribution_tomtom_layers.includes(activeLayerId)) {
          //show tomtom attribution
          document.querySelector('.hideAttributionFromLevel').classList.remove('hide');
        } else {
          //hide tomtom
          document.querySelector('.hideAttributionFromLevel').classList.add('hide');
        }
        if (zoomlevel < 6) {
          if ((activeLayerId === 'crossborder.topo')) {
            document.querySelector('.hideAttributionFromLevel-2').classList.remove('hide');
          } else {
            document.querySelector('.hideAttributionFromLevel-2').classList.add('hide');
          }
        }
      })
    );



    this.mapService.getMap().on("moveend", (event) => {
      let querystring = window.location.search;
      //tomtom copyright
      if ((querystring.indexOf('cartoweb') > -1) || (querystring.indexOf('overlay') > -1) || (querystring.indexOf('crossborder.topo') > -1)) {
        const zoomlevel: number = event.map.getView().getZoom();
        if (zoomlevel > 7) {
          document.querySelector('.hideAttributionFromLevel').classList.remove('hide');
        } else {
          document.querySelector('.hideAttributionFromLevel').classList.add('hide');
        }
      }
      //eurographics copyright
      if ((querystring.indexOf('crossborder.topo') > -1)) {
        const zoomlevel: number = event.map.getView().getZoom();
        if (zoomlevel < 6) {
          document.querySelector('.hideAttributionFromLevel-2').classList.remove('hide');
        } else {
          document.querySelector('.hideAttributionFromLevel-2').classList.add('hide');
        }
      }
    })
  }

  private setTraceReadOnListener() {
    this._traceReadOnListener = this._popupService.customEvent.subscribe((eventObj) => {
      if (
        //this.isActive &&
        eventObj &&
        eventObj.detail &&
        eventObj.detail.eventId &&
        eventObj.detail.eventId === 'TraceInfoReadOn' &&
        eventObj.detail.data &&
        typeof eventObj.detail.data.isPoi === 'boolean' &&
        Array.isArray(eventObj.detail.data.ref) &&
        ((eventObj.detail.data.isPoi && eventObj.detail.data.ref.length === 1) || (!eventObj.detail.data.isPoi && eventObj.detail.data.ref.length === 2))
      ) {
        const pointObj: TraceWayPointType = eventObj.detail.data.isPoi ? this.traceService.getTraceRouteData_wayPoint(eventObj.detail.data.ref[0]) : this.traceService.getTraceRouteData_routePoint(eventObj.detail.data.ref[0], eventObj.detail.data.ref[1]); if (pointObj) {
          if (this._popupService.isPopupAlreadyOnMap()) {
            this._popupService.hide();
          }
          this.traceService.openViewDialog(
            {
              ref: eventObj.detail.data.isPoi ? 'wayPoint_' + eventObj.detail.data.ref[0] : 'routePoint_' + eventObj.detail.data.ref[0] + '_' + eventObj.detail.data.ref[1],
              isPoi: eventObj.detail.data.isPoi, isNew: false
            }
          );
          window.setTimeout(() => {
            this.traceService.addWayPointHighlight(
              eventObj.detail.data.ref[0],
              true
            );
          }, 300);
        }
      }
    })
  }

  private setSuggestionsListener() {
    this._traceSuggestionsListener = this._popupService.customEvent.subscribe((eventObj) => {
      if (
        this.traceService.isActive() &&
        eventObj &&
        eventObj.detail &&
        eventObj.detail.eventId &&
        eventObj.detail.eventId === 'TraceSuggestionInfo' &&
        eventObj.detail.data &&
        typeof eventObj.detail.data.routeId === 'string' &&
        eventObj.detail.data.routeId.trim().length > 0
      ) {
        if (this._popupService.isPopupAlreadyOnMap()) {
          this._popupService.hide();
        }
        this.traceService.openSuggestionsRoute(eventObj.detail.data.routeId, false);
      }
    })
  }

  private handleSizeChange(isPhone: boolean) {
    if (isPhone) {
      if (this.traceService.isInEditingMode()) {
        this.traceService.onOpenCreateMobile();
      }
      if (!this._traceReadOnListener) { this.setTraceReadOnListener() }
      this._subscriptions.add(this._traceReadOnListener);
      if (!this._traceSuggestionsListener) { this.setSuggestionsListener() }
      this._subscriptions.add(this._traceSuggestionsListener);
    } else {
      this.traceService.closeViewDialog();
      this.traceService.closeImportDialog();
      this.traceService.closeSuggestionsDialog();

      if (this.traceService.isInEditingMode()) {
        this.traceService.closeCreateBottomSheet();
        this.traceService.openTraceTab(TraceDrawerType.CREATE_ROUTE);
      }
      if (this._traceReadOnListener) {
        this._subscriptions.remove(this._traceReadOnListener);
        this._traceReadOnListener.unsubscribe();
        this._traceReadOnListener = null;
      }
      if (this._traceSuggestionsListener) {
        this._subscriptions.remove(this._traceSuggestionsListener);
        this._traceSuggestionsListener.unsubscribe();
        this._traceSuggestionsListener = null;
      }
    }
  }
}